import React from 'react';
import { BrainCircuitIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 relative" data-id="element-111">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-112">
        <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-113">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/10 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" data-id="element-114" />

          <div className="flex items-center gap-4 mb-8" data-id="element-115">
            <div className="w-12 h-12 rounded-xl bg-cyan-500/20 border border-cyan-500/30 flex items-center justify-center text-cyan-400 shadow-[0_0_15px_rgba(34,211,238,0.2)]" data-id="element-116">
              <BrainCircuitIcon className="w-6 h-6" data-id="element-117" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-50" data-id="element-118">
              El Sistema se Satura
            </h2>
          </div>

          <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-119">
            <p data-id="element-120">
              El cerebro con TDAH o tendencia a la sobreestimulación procesa
              miles de estímulos por segundo.
            </p>
            <p data-id="element-121">
              Cuando intentas trabajar, tu mente no solo ve la tarea;{' '}
              <span className="text-slate-50 font-medium" data-id="element-122">
                ve el correo que no respondiste, el ruido del vecino, la luz
                demasiado brillante y el miedo a fallar otra vez.
              </span>
            </p>
            <div className="pl-6 border-l-2 border-cyan-500/50 py-2 my-6" data-id="element-123">
              <p className="text-xl text-slate-200 font-medium italic" data-id="element-124">
                "Tu capacidad ejecutiva se congela. El sistema se satura."
              </p>
            </div>
            <p data-id="element-125">
              Y mientras más intentas "forzarte" a concentrarte, más fuerte se
              vuelve el ruido interno, dejándote exhausto y con la sensación de
              que has perdido otro día antes de empezarlo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}